// import React, { useState } from 'react';

// import { openDB } from 'idb';

// const VideoUploader = () => {
//   const [videoSrc, setVideoSrc] = useState(null);

//   console.log("videoUrl",videoSrc);
//   // Initialize the IndexedDB database with proper error handling
//   const initDB = async () => {
//     try {
//       const db = await openDB('video-store', 1, {
//         upgrade(db) {
//           if (!db.objectStoreNames.contains('videos')) {
//             db.createObjectStore('videos', { keyPath: 'id' });
//           }
//         },
//       });
//       return db;
//     } catch (error) {
//       console.error('Failed to initialize IndexedDB', error);
//     }
//   };

//   // Store video in IndexedDB with error handling
//   const storeVideoInDB = async (file) => {
//     try {
//       const db = await initDB();
//       const tx = db.transaction('videos', 'readwrite');
//       const store = tx.objectStore('videos');
//       const blob = new Blob([file], { type: file.type });

//       await store.put({ id: 'video', videoBlob: blob });
//       await tx.done;
//       console.log('Video stored successfully in IndexedDB');
//     } catch (error) {
//       console.error('Failed to store video in IndexedDB', error);
//     }
//   };

//   // Load video from IndexedDB with error handling
//   const loadVideoFromDB = async () => {
//     try {
//       const db = await initDB();
//       const tx = db.transaction('videos', 'readonly');
//       const store = tx.objectStore('videos');
//       const storedVideo = await store.get('video');
//       await tx.done;

//       if (storedVideo) {
//         const videoUrl = URL.createObjectURL(storedVideo.videoBlob); 
//         setVideoSrc(videoUrl); 

//         //here set the video in localStorage
//         localStorage.setItem('video', URL.createObjectURL(storedVideo.videoBlob));

//       } else {
//         alert('No video found in IndexedDB');
//       }
//     } catch (error) {
//       console.error('Failed to load video from IndexedDB', error);
//     }
//   };

//   const handleVideoUpload = async (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       await storeVideoInDB(file); // Store the video in IndexedDB
//       loadVideoFromDB(); // Load the video to display
//     } else {
//       console.error('No file selected');
//     }
//   };

//   return (
//     <div>
//       <h3>Upload and Store Video in IndexedDB</h3>
//       <input type="file" accept="video/*" onChange={handleVideoUpload} />
//       <button onClick={loadVideoFromDB}>Load Video from IndexedDB</button>
//       {videoSrc && (
//         <video controls width="500">
//           <source src={videoSrc} type="video/mp4" />
//           Your browser does not support the video tag.
//         </video>
//       )}
//     </div>
//   );
// };

// export default VideoUploader; 

import React, { useState, useEffect } from "react";
import { openDB } from "idb";

const VideoUploader = () => {
  const [videoFile, setVideoFile] = useState(null);
  const [videoList, setVideoList] = useState([]);

  // Initialize IndexedDB
  const initDB = async () => {
    const db = await openDB("videoStore", 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains("videos")) {
          db.createObjectStore("videos", { keyPath: "id", autoIncrement: true });
        }
      },
    });
    return db;
  };

  // Save video to IndexedDB
  const saveVideo = async (file) => {
    const db = await initDB();
    const transaction = db.transaction("videos", "readwrite");
    const store = transaction.objectStore("videos");
    const videoBlob = new Blob([file], { type: file.type });

    try {
      await store.add({ video: videoBlob });
      await transaction.done;
      alert("Video saved successfully!");
      loadVideos(); // Reload videos after saving
    } catch (error) {
      console.error("Error saving video:", error);
    }
  };

  // Load all videos from IndexedDB
  const loadVideos = async () => {
    const db = await initDB();
    const transaction = db.transaction("videos", "readonly");
    const store = transaction.objectStore("videos");
    const videos = await store.getAll(); // Fetch all videos

    if (videos.length > 0) {
      const urls = videos.map((videoObj) => URL.createObjectURL(videoObj.video));
      console.log("urls", urls);
      setVideoList(videos); // Store the actual video objects to access IDs later
    } else {
      console.warn("No videos found in IndexedDB");
      setVideoList([]); // Clear the list if no videos are found
    }
  };

  // Delete video from IndexedDB
  const deleteVideo = async (id) => {
    const db = await initDB();
    const transaction = db.transaction("videos", "readwrite");
    const store = transaction.objectStore("videos");

    try {
      // await store.delete(id); // Delete the video by ID 
      // await transaction.done;
      // alert("Video deleted successfully!");
      // loadVideos(); // Reload videos after deleting

      await store.clear(); // Delete all data from the store
      await transaction.done;
      alert("All videos deleted successfully!");
      setVideoList([]); // Clear the list after deleting
    } catch (error) {
      console.error("Error deleting video:", error);
    }
  };

  // Handle file input change
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setVideoFile(file);
  };

  // Handle the save action
  const handleSave = () => {
    if (videoFile) {
      saveVideo(videoFile);
    } else {
      alert("Please select a video file first.");
    }
  };

  // Load videos when the component mounts
  useEffect(() => {
    loadVideos();
  }, []);

  // Cleanup URL object when component unmounts
  useEffect(() => {
    return () => {
      videoList.forEach((video) => {
        URL.revokeObjectURL(video.video); // Revoke each URL to avoid memory leaks
      });
    };
  }, [videoList]);

  return (
    <div>
      <h1>Video Storage</h1>
      <input type="file" accept="video/*" onChange={handleFileChange} />
      <button onClick={handleSave}>Save Video</button>

      {videoList.length > 0 && (
        <div>
          <h3>Stored Videos:</h3>
          {videoList.map((videoObj) => (
            <div key={videoObj.id}>
              <video controls width="500" src={URL.createObjectURL(videoObj.video)} />
              <button onClick={() => deleteVideo(videoObj.id)}>Delete Video</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VideoUploader;
